import { Box } from "@jewlr/storybook/core"
import Autoplay from "embla-carousel-autoplay"
import PropTypes from "prop-types"

import Textarea from "components/landing/textarea"
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel"

import ProductCarouselItem from "./product-carousel-item"

const ProductCarousel = ({ data, lazyload, linkClickData }) => {
  const {
    bottom_textarea,
    carousel_container_style,
    carousel_section_style,
    image_container_style,
    name,
    slides,
    slider_settings,
    top_textarea,
  } = data

  const { autoplayInterval = 4000, ...sliderSettings } = slider_settings || {}

  return (
    <Box {...carousel_section_style}>
      {top_textarea && (
        <Textarea
          element={top_textarea}
          linkClickData={linkClickData}
          style={top_textarea.style}
        />
      )}
      <Box {...carousel_container_style}>
        <Carousel
          aria-label={name}
          opts={sliderSettings}
          plugins={[
            Autoplay({
              delay: autoplayInterval,
            }),
          ]}
        >
          <CarouselContent>
            {slides.map((slide, index) => (
              <CarouselItem key={`${name}-${index}`}>
                <ProductCarouselItem
                  imageContainerStyle={image_container_style}
                  index={index}
                  lazyload={lazyload}
                  linkClickData={linkClickData}
                  slide={slide}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </Box>
      {bottom_textarea && (
        <Textarea
          element={bottom_textarea}
          linkClickData={linkClickData}
          style={bottom_textarea.style}
        />
      )}
    </Box>
  )
}

ProductCarousel.propTypes = {
  data: PropTypes.object,
  lazyload: PropTypes.bool,
  linkClickData: PropTypes.string,
}

export default ProductCarousel
